import {getUserAgentData} from 'app/helpers/helpers';
const {browser} = getUserAgentData();

export const PARALLAX_SLOT_IDS = ['ad-Rectangle_1', 'ad-Rectangle_2', 'ad-Content_2'];
export const PARALLAX_AD_UNITS = ['Rectangle_1', 'Rectangle_2', 'Content_2'];
export const PARALLAX_SIZES = ['300x600', '320x480'];
export const IS_CHROME = browser.startsWith('Chrome');
export const WEB_INTERSTITIAL_SLOT_ID = 'web_interstitial';
